import { MainImage } from "@omni/types/api/shared/bff/mainImage.model";
import * as yup from "yup";

import { GiftCardType } from "@/utils/enums";
import * as RHFGiftCardValidationRules from "@/utils/validation/schemas/giftCard.RHF";

export const RequiredGiftCardSchema = yup.object({
    sku: RHFGiftCardValidationRules.giftCardSku
});

export type RequiredGiftCardFormValues = yup.InferType<
    typeof RequiredGiftCardSchema
>;

export type GiftCard = {
    sku: string;
    images: Array<MainImage>;
    title: string;
    type: GiftCardType;
};
